export class InsurerDataConsts {

  static EMAIL = 'email';
  static PHONE_NUMBER = 'phoneNumber';
  static LAST_NAME = 'lastName';
  static FIRST_NAME = 'firstName';
  static PESEL = 'pesel';

  static CITY = 'address.city';
  static COUNTY = 'address.county';
  static STREET = 'address.street';
  static FLAT_NUMBER = 'address.flatNumber';
  static COUNTRY_CODE = 'address.countryCode';
  static BUILDING_NUMBER = 'address.buildingNumber';
  static POSTAL_CODE = 'address.postalCode';

}
